import React ,{ReactNode,FC}from 'react'

interface ListTitleProps {
    children: ReactNode
}

export const ListTitle:FC<ListTitleProps> = ({children}) => {
  return (
      <h6 className='m-0' style={{color:'#06152B',fontSize:'14px', fontWeight:500}}>{children}</h6>
  )
}